import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { URL, USER, platformsSupportedForPhleboUpsell } from "../../constants/constant";
import { _axios } from "../../plugins/axios";
import { geolocated } from "react-geolocated";
import { Form } from "react-bootstrap";
import PackageDetails from "../common/packageDetails";
import DependantHeaderSample from "../common/dependantHeaderSample";
import { UserLoginDialog } from "../newUpsell/userLoginDialog";

class DependantOrderDetailsCollected extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userdata: USER.user,
      orderStatus: null,
      orderDetails: null,
      statusDetails: null,
      cameraToggle: false,
      sampleCollection: localStorage.getItem("phlebo_start_order_trip_details")
        ? JSON.parse(localStorage.getItem("phlebo_start_order_trip_details"))
        : null,
      dependantId: this.props.match.params.dependantId.toString(),
      showSnackbar: false,
      messageSnacks: "",
      showReachedButton: localStorage.getItem("phlebo_start_order_trip_details") ? false : true,
      acceptDisable: true,
      lat: "11.0553N", //pass the latitude
      lon: "76.9940E", //pass the longitude
      location: "4, opp to fire station, 1, Bannerghatta Main Rd, Bengaluru, Karnataka 560029", //pass the location
      loader: true,
      latitude: "0.0",
      longitude: "0.0",
      labCentersAvailable: [],
      labAssigned: true,
      reassignLab: false,
      labId: null,
      labCentersAvailable: [],
      showPackageInfo: false,
      loadPackageDetails: false,
      openOrderCreationPopup: false,
      latlongEventTriggerFunction: (ev) => {
        const that = this;
        console.log("lat long received event triggered", ev.detail);

        if (ev.detail !== null && ev.detail !== undefined) {
          const latlong = ev.detail.split(",");
          console.log("lat long split in an arr ", latlong);
          if (latlong !== null && latlong !== undefined) {
            this.state.latitude = latlong[0];
            this.state.longitude = latlong[1];
            that.markOrderReached();
          } else {
            that.showSnackbarFun("Location not received1, cannot continue", 2500);
          }
        } else {
          that.showSnackbarFun("Location not received, cannot continue", 2500);
        }
        ev.stopImmediatePropagation();
      },
    };
  }

  componentDidMount() {
    this.addEventListeners();
    this.getOrderDetails();
  }

  componentWillUnmount() {
    this.cleanupListener();
  }

  cleanupListener() {
    if (typeof android !== "undefined" && android !== null) {
      window.removeEventListener("setLatLongFromApp", this.state.latlongEventTriggerFunction);
      console.log("cleanupListener : ", this.state.latlongEventTriggerFunction);
    }
  }

  addEventListeners() {
    if (typeof android !== "undefined" && android !== null) {
      window.addEventListener("setLatLongFromApp", this.state.latlongEventTriggerFunction);
      console.log("addEventListeners : ", this.state.latlongEventTriggerFunction);
    }
  }



  fetchImages(statusDetails) {
    let phleboImageURL, sampleImageURL;
    _axios
      .get(`${URL.dev_url}downloadGuid?guid=${statusDetails.phleboImage[0]}`)
      .then((response) => {
        phleboImageURL = response.data.signedUrl;
        this.setState({
          phleboImageURL: phleboImageURL
        })
      });
    _axios
      .get(`${URL.dev_url}downloadGuid?guid=${statusDetails.patientDetails[0].sampleImage[0]}`)
      .then((response) => {
        sampleImageURL = response.data.signedUrl;
        this.setState({
          sampleImageURL: sampleImageURL
        })
      });
  }

  getOrderDetails() {
    const that = this;
    let url = URL.dev_url;
    let route = url + "getorders";
    let obj = {
      phleboId: this.state.userdata.phleboId,
      dependantId: this.state.dependantId,
    };

    that.setState({
      loader: true,
    });

    _axios
      .post(route, obj)
      .then(function (response) {
        let data;
        let sampleCollected = false;
        if (response.data.sampleTakenOrders && response.data.sampleTakenOrders.length) {
          data = response.data.sampleTakenOrders;
          sampleCollected = true;
        } else if (response.data.completedOrders && response.data.completedOrders.length) {
          data = response.data.completedOrders;
        } else {
          data = response.data.sampleTakenOrders;
        }
        if (response.data.success) {
          USER.orderDetails = response.data;
          localStorage.setItem("order_details", JSON.stringify(response.data));
          that.setState(
            {
              orderDetails: response.data,
              statusDetails: data,
              loadPackageDetails: true,
              customerNumber: data[0].patientDetails[0].phoneNumber,
              sampleCollected: sampleCollected
            },
            () => {
              localStorage.setItem("customer_phoneNumber", data[0].patientDetails[0].phoneNumber);
            }
          );
          that.getLabCenters();
          that.fetchImages(data[0]);
        }
      })
      .catch(function (error) {
        that.setState({
          loader: false,
        });
      });
  }
  getLabCenters() {
    const that = this;
    that.setState({
      loader: true,
    });
    let route = URL.dev_url + "getAllSPCByCity?city=" + USER.user.city;
    _axios
      .get(route)
      .then(function (res) {
        that.setState({
          loader: false,
          labCentersAvailable: res.data,
        });
      })
      .catch(function (err) {
        console.log(err);
        that.setState({
          loader: false,
          labAssigned: false,
        });
      });
  }
  showPackageInfoModal(appointmentId, testName) {
    this.setState({
      showPackageInfo: !this.state.showPackageInfo,
      appointmentIdToGetPackageDetails: appointmentId,
      nameOfTestToGetPackageDetails: testName,
    });
  }
  handleLabCenterChange(event) {
    event.preventDefault();
    this.setState({ labId: event.target.value });
  }
  updateLabCenter(val) {
    let dependantId = this.state.dependantId;

    const that = this;
    if (!this.state.labId) {
      this.showSnackbarFun("Please select lab center", 3000);
      return;
    }
    let route = URL.dev_url + "updateSPCForOrderId";
    _axios
      .post(route, {
        dependantId: dependantId,
        spcId: this.state.labId || val,
        executeAtPatientLevel: true,
      })
      .then(function (res) {
        window.location.reload();
        that.setState({
          labAssigned: true,
        });
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  redirectToOTP(dependantId, phoneNo) {
    let x = "/dependantOtp/customer/" + dependantId;
    localStorage.setItem("customer_phoneNumber", JSON.stringify(phoneNo));
    this.props.history.push(x);
  }

  redirectToOrderDetails() {
    let x = "/dependantOrders";
    this.props.history.push(x);
  }

  addMoreTests() {
    localStorage.removeItem("userName")
    localStorage.removeItem("selectedBenef")
    localStorage.removeItem("cart")
    localStorage.removeItem("user_short_token")
    localStorage.removeItem("parentOrderDetails")
    let parentOrderDetails = { ...this.state.statusDetails[0].patientDetails[0], orderDateTime: this.state.statusDetails[0].orderDateTime, orderId: this.state.statusDetails[0].prOrderId}
    localStorage.setItem("parentOrderDetails", JSON.stringify(parentOrderDetails))
    localStorage.setItem("userName", this.state.statusDetails?.[0]?.patientDetails?.[0]?.userName)
    this.setState( {openOrderCreationPopup: true} );
  }

  render() {
    return (
      <div>
        <div className="main">
          {this.state.loader ? (
            <p style={{ textAlign: "center" }}>Loading...</p>
          ) : (
            <p>
              <div className="order-details-dashboard">
                <div>
                  <div className="header-sample">
                    <i className="fa fa-chevron-circle-left" onClick={() => this.props.history.push('/dependantOrders')}></i>
                  </div>
                  {!this.state.loader ? (
                    <DependantHeaderSample
                      titleCall={false}
                      orderHeader={this.state.statusDetails[0]}
                      noCall={this.state.statusDetails[0].noCall}
                    ></DependantHeaderSample>
                  ) : (
                    ""
                  )}
                </div>
                <div>
                  <Container>
                    <Row>
                      <Col xs={12} md={12}>
                        <div className="p-l-10 p-r-10 p-t-10">
                          <Row className="font-size-md bold">
                            <Col xs={6} md={6}>
                              <i className="fa fa-flask m-r-10" aria-hidden="true"></i>
                              Tests
                            </Col>
                            <Col xs={6} md={6} className="text-align-right">
                              {false && this.state.statusDetails && this.state.sampleCollected && platformsSupportedForPhleboUpsell.includes(this.state.statusDetails[0].platform?.toLowerCase()) && <Button type="submit" size="sm" onClick={() => this.addMoreTests()}>
                                Add More
                              </Button>}
                            </Col>
                          </Row>
                          <div className="font-size-smd">
                            <ol>
                              {this.state.statusDetails
                                ? this.state.statusDetails.map((order) => {
                                    return order.tests.map((elem) => {
                                      return (
                                        <li key={elem.testId}>
                                          {`${elem.testName} - ${order.appointmentId}`}
                                          <button
                                            className="btn btn-default"
                                            onClick={() => this.showPackageInfoModal(order.appointmentId, elem.testName)}
                                          >
                                            <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="15px" height="15px">
                                              <path d="M25,2C12.297,2,2,12.297,2,25s10.297,23,23,23s23-10.297,23-23S37.703,2,25,2z M25,11c1.657,0,3,1.343,3,3s-1.343,3-3,3 s-3-1.343-3-3S23.343,11,25,11z M29,38h-2h-4h-2v-2h2V23h-2v-2h2h4v2v13h2V38z" />
                                            </svg>
                                          </button>
                                          {elem.testDetails != null ? (
																						<div className="display-flex justify-content-space-between p-b-10">
																							<div className="break-words">
																								{"Test Details: " +
																									elem.testDetails}
																							</div>
																						</div>
																					) : (
																						<></>
																					)}
                                        </li>
                                      );
                                    });
                                  })
                                : ""}
                            </ol>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row className="p-b-20">
                      <Col xs={12} md={12}>
                        <div className="p-10">
                          <div className="font-size-sm">
                            <i className="fa fa-map-marker width-5 p-l-2 p-b-10" aria-hidden="true"></i>
                            <span>Lab Address</span>
                          </div>
                          <div className="font-size-smd bold p-l-15">
                            {this.state.statusDetails &&
                            this.state.statusDetails[0].labDetails &&
                            this.state.statusDetails[0].labDetails.AssignedLab &&
                            !this.state.reassignLab ? (
                              <>
                                <span> {this.state.statusDetails[0].labDetails.AssignedLab}, </span>
                                <span>
                                  {" "}
                                  {this.state.statusDetails[0].labDetails.AssignedLabAddress +
                                    ", " +
                                    this.state.statusDetails[0].labDetails.AssignedLabPincode}{" "}
                                </span>
                              </>
                            ) : (
                              <Form onSubmit={(e) => this.updateLabCenter(this.state.labId)}>
                                <Form.Group controlId="formGroupSelectLabCenter">
                                  <Form.Label>Select a Lab Center</Form.Label>
                                  <Form.Control as="select" onChange={(e) => this.handleLabCenterChange(e)}>
                                    <option value="">Select</option>
                                    {this.state.labCentersAvailable.map((each, idx) => (
                                      // {each.labId}
                                      <option key={idx} value={each.labid}>
                                        {each.labName + ", " + each.labaddressline1}
                                      </option>
                                    ))}
                                  </Form.Control>
                                </Form.Group>
                                <Button variant="primary" type="submit" className="text-align-center w-100">
                                  Save
                                </Button>
                              </Form>
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                    {(this.state.statusDetails[0].phleboImage || this.state.statusDetails[0].patientDetails[0].sampleImage) && (
                      <Row>
                        {this.state.statusDetails[0].phleboImage && (
                          <Col xs={12} md={6} className="p-2">
                            <div className="card" style={{ width: "100" }}>
                              <div className="card-body">
                                <h5 className="card-title">Phelbo: </h5>
                              </div>
                              <img
                                className="card-img-top"
                                src={`${this.state.phleboImageURL}`}
                                alt="Card image cap"
                              ></img>
                            </div>
                          </Col>
                        )}
                        {this.state.statusDetails[0].patientDetails[0].sampleImage && (
                          <Col xs={12} md={6} className="p-2">
                            <div className="card" style={{ width: "100" }}>
                              <div className="card-body">
                                <h5 className="card-title">Test Samples: </h5>
                              </div>
                              <img
                                className="card-img-top"
                                src={`${this.state.sampleImageURL}`}
                                alt="Card image cap"
                              ></img>
                            </div>
                          </Col>
                        )}
                      </Row>
                    )}
                  </Container>
                </div>

                <div>
                  <Container>
                    <Row>
                      <div className="fixed-bottom p-l-15 p-r-15 p-t-5 p-b-5">
                        <div className="display-flex justify-content-space-between">
                          {this.state.statusDetails[0].orderStatus.currentStatusId === 5 && (
                            <Col>
                              <button
                                type="button"
                                className="btn btn-outline-primary width-100 border-curve-10"
                                onClick={() => {
                                  this.redirectToOTP(this.state.statusDetails[0].dependantId, this.state.statusDetails[0].patientDetails[0].phoneNumber);
                                }}
                              >
                                OTP Verification
                              </button>
                            </Col>
                          )}
                        </div>
                      </div>
                    </Row>
                  </Container>
                </div>
              </div>
            </p>
          )}
        </div>
        {this.state.showPackageInfo && (
          <PackageDetails
            showPackageInfo={this.state.showPackageInfo}
            showPackageInfoModal={() => this.showPackageInfoModal()}
            appointmentId={this.state.appointmentIdToGetPackageDetails}
            packageName={this.state.nameOfTestToGetPackageDetails}
          />
        )}
        {this.state.openOrderCreationPopup && (
          <UserLoginDialog
            userName={this.state.statusDetails?.[0]?.patientDetails?.[0]?.userName}
            getControl={(status) => this.setState({ openOrderCreationPopup: status })}
            errorAlert={(err) => err && alert(err)}
          />
        )}
      </div>
    );
  }
}

export default geolocated({
  positionOptions: {
    enableHighAccuracy: true,
  },
  userDecisionTimeout: 50000,
})(DependantOrderDetailsCollected);
